// **Die Meldung unten** (`pf-toast`): eine zur Zeit, die neue ersetzt die alte,
// nach 4,5 s weg. Ein kleiner Speicher außerhalb von React, damit auch Code
// ohne Komponente (der 401-Handler in main.tsx) melden kann.

import { useSyncExternalStore } from "react";
import { createPortal } from "react-dom";

export interface ToastState {
  id: number;
  message: string;
  tone: "" | "error";
}

let current: ToastState | null = null;
let seq = 0;
let timer: ReturnType<typeof setTimeout> | null = null;
const listeners = new Set<() => void>();

function emit(): void {
  for (const l of listeners) l();
}

export function toast(message: string, tone: "" | "error" = ""): void {
  current = { id: ++seq, message, tone };
  if (timer) clearTimeout(timer);
  timer = setTimeout(() => { current = null; timer = null; emit(); }, 4500);
  emit();
}

/** Für Tests: alles zurück auf Anfang. */
export function resetToasts(): void {
  if (timer) clearTimeout(timer);
  timer = null;
  current = null;
  emit();
}

export function currentToast(): ToastState | null {
  return current;
}

function subscribe(fn: () => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function Toaster() {
  const t = useSyncExternalStore(subscribe, currentToast, currentToast);
  if (!t) return null;
  return createPortal(
    <div key={t.id} className={`pf-toast${t.tone ? ` pf-toast--${t.tone}` : ""}`} role="status">{t.message}</div>,
    document.body,
  );
}
